import React from 'react';

import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const HistoryIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M12 7.5V12'
				stroke={props?.isTitle ? colors.white : colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.9 14.25L12 12'
				stroke={props?.isTitle ? colors.white : colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.73126 9.34686H2.98126V5.59686'
				stroke={props?.isTitle ? colors.white : colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.16876 17.8313C7.32228 18.9857 8.79228 19.7721 10.3928 20.091C11.9933 20.4099 13.6525 20.2469 15.1604 19.6227C16.6682 18.9984 17.9571 17.941 18.8639 16.5842C19.7707 15.2273 20.2548 13.632 20.2548 12C20.2548 10.368 19.7707 8.7727 18.8639 7.41585C17.9571 6.059 16.6682 5.00158 15.1604 4.37735C13.6525 3.75313 11.9933 3.59014 10.3928 3.90902C8.79228 4.22789 7.32228 5.0143 6.16876 6.16875L2.98126 9.34688'
				stroke={props?.isTitle ? colors.white : colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default HistoryIcon;
